import Splide from '@splidejs/splide';

const initCaseStudies = (slider) => {
  const slides = slider.querySelectorAll('.splide__slide').length;

  if (!slides) {
    return;
  }

  const splide = new Splide(slider, {
    type: slides > 1 ? 'loop' : 'slide',
    perPage: 1,
    perMove: 1,
    focus: 0,
    gap: '2.75rem',
    padding: { right: '32%' },
    arrows: slides > 1,
    pagination: slides > 1,
    speed: 650,
    drag: slides > 1,
    keyboard: 'focused',
    breakpoints: {
      1024: {
        padding: { right: '10%' },
      },
      768: {
        padding: { right: '12%' },
      },
      640: {
        padding: { right: '0' },
      },
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
  });

  const updateCarouselUi = () => {
    const track = slider.querySelector('.splide__track');
    const activeSlide = splide.Components.Slides.getAt(splide.index)?.slide;

    if (!track || !activeSlide) {
      return;
    }

    const sliderRect = slider.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();
    const previousX = trackRect.left - sliderRect.left;
    const gap =
      parseFloat(window.getComputedStyle(activeSlide).marginRight) || 0;
    const nextX = previousX + activeSlide.offsetWidth + gap;

    slider.style.setProperty(
      '--case-studies-track-center',
      `${trackRect.top - sliderRect.top + trackRect.height / 2}px`
    );
    slider.style.setProperty('--case-studies-prev-x', `${previousX}px`);
    slider.style.setProperty('--case-studies-next-x', `${nextX}px`);
  };

  splide.on('mounted moved resized', () => {
    window.requestAnimationFrame(updateCarouselUi);
  });
  splide.mount();

  slider.querySelectorAll('img').forEach((image) => {
    image.addEventListener('load', updateCarouselUi);
  });

  initDragCursor(slider, splide);
};

/**
 * Replace the pointer with a coral circle + arrow while hovering the slides.
 * The arrow always aims at the top-right corner so it reads as a link, and a
 * click advances the carousel.
 */
const initDragCursor = (slider, splide) => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  const track = slider.querySelector('.splide__track');

  if (!track) {
    return;
  }

  const cursor = document.createElement('div');
  cursor.className = 'case-studies__cursor';
  cursor.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17L17 7M8 7h9v9"/></svg>';
  slider.appendChild(cursor);

  const isNext = (x) => {
    const rect = track.getBoundingClientRect();
    return x >= rect.left + rect.width / 2;
  };

  track.addEventListener('mouseenter', () => cursor.classList.add('is-active'));
  track.addEventListener('mouseleave', () =>
    cursor.classList.remove('is-active')
  );
  track.addEventListener('mousemove', (event) => {
    cursor.style.left = `${event.clientX}px`;
    cursor.style.top = `${event.clientY}px`;
  });
  track.addEventListener('click', (event) => {
    if (event.target.closest('a, button')) {
      return;
    }

    splide.go(isNext(event.clientX) ? '>' : '<');
  });
};

const initAll = () => {
  document.querySelectorAll('.case-studies__slider').forEach((slider) => {
    if (slider.classList.contains('is-initialized')) {
      return;
    }

    initCaseStudies(slider);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
